module.exports = __webpack_public_path__ + "bfc68193a566996b4f7570be1e8dd7b9.png";


//////////////////
// WEBPACK FOOTER
// ./img/logos/antivirus/16x16_v3.png
// module id = 1295
// module chunks = 0 1